import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import DatePicker from 'react-datepicker';

const ChartControls = ({
    startDate, endDate, handleStartDateChange, handleEndDateChange,
}) => (
    <Form className="mb-4">
        <Row>
            <Col md={3}>
                <Form.Group controlId="startDate">
                    <DatePicker
                        selected={new Date(startDate)}
                        onChange={handleStartDateChange}
                        showTimeSelect
                        dateFormat="Pp"
                        className="form-control"
                        timeIntervals={15}
                        minDate={new Date(0)}
                        minTime={new Date(0)}
                        maxDate={new Date(Date.now() - 180000)}
                        maxTime={new Date(Date.now() - 180000)}
                    />
                </Form.Group>
            </Col>
            <Col md={3}>
                <Form.Group controlId="endDate">
                    <DatePicker
                        selected={new Date(endDate)}
                        onChange={handleEndDateChange}
                        showTimeSelect
                        dateFormat="Pp"
                        className="form-control"
                        timeIntervals={15}
                        minDate={new Date(0)}
                        minTime={new Date(0)}
                        maxDate={new Date(Date.now() - 120000)}
                        maxTime={new Date(Date.now() - 120000)}
                    />
                </Form.Group>
            </Col>
        </Row>
    </Form>
);

export default ChartControls;
